/** The upload descriptor's header values, as the server signed them into the presigned PUT. */
interface PresignedPutHeaderValues {
	contentType: string;
	contentMd5: string;
	contentDisposition: string;
}

/** The headers a presigned upload PUT sends; S3 refuses the signature if a signed one is missing or altered. */
export const uploadPutHeaders = ({
	contentType,
	contentMd5,
	contentDisposition,
}: PresignedPutHeaderValues): Record<string, string> => ({
	'Content-Type': contentType,
	'Content-MD5': contentMd5,
	'Content-Disposition': contentDisposition,
});
